import { UseQueryOptions } from '@tanstack/react-query';
import { parseISO } from 'date-fns';

import useAppQuery from 'hooks/useAppQuery';
import { BaseErrorResponse } from 'models/_base';
import {
  GetMessageLogsByUidResponseTO,
  MessageLogByUid,
  MessageLogByUidApiTO,
} from 'models/automation/MessageLogs';
import API from 'services/API';
import { MESSAGE_LOGS_BASE_QUERY_KEY } from './messageLogsQuery';

type ReactQueryOptions = Omit<
  UseQueryOptions<MessageLogByUid, BaseErrorResponse>,
  'queryKey' | 'queryFn'
>;

type UseFetchMessageLogByUidArgs = {
  messageLogUid: string;
} & ReactQueryOptions;

const parseMessageLog = (data: MessageLogByUidApiTO): MessageLogByUid => {
  return {
    ...data,
    createdAt: data.createdAt ? parseISO(data.createdAt) : null,
    executionTime: data.executionTime ? parseISO(data.executionTime) : null,
    lastRetryTime: data.lastRetryTime ? parseISO(data.lastRetryTime) : null,
    updatedAt: data.updatedAt ? parseISO(data.updatedAt) : null,
  };
};

const useFetchMessageLogByUid = ({
  messageLogUid,
  enabled = true,
  ...options
}: UseFetchMessageLogByUidArgs) => {
  return useAppQuery<MessageLogByUid, BaseErrorResponse>({
    queryKey: [MESSAGE_LOGS_BASE_QUERY_KEY, 'detail', messageLogUid],
    queryFn: async () => {
      const response = await API.get<GetMessageLogsByUidResponseTO>(
        `/api/internal/trigger-logs/${messageLogUid}`,
      );

      return parseMessageLog(response.data.triggerLog);
    },
    enabled,
    staleTime: 30000,
    ...options,
  });
};

export default useFetchMessageLogByUid;
